import { addPointInteger, capitalizarTexto } from 'vlcishared';
import { TEXTS_SEGURIDAD } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';
import { COLORS } from '../colors';

// Gráfica pestaña HOY | Tarta de Intervenciones totales Nivel 1
export const OPTIONS_INTERVENCIONES_PIE = {
  color: Object.values(COLORS),
  grid: {
    left: '0',
    right: '0',
    bottom: '0',
    top: '60',
    containLabel: true,
  },
  title: {
    text: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('intervenciones_totales'),
    subtext: `${TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('tipologia_nivel')  } 1`,
    left: 'center',
    top: '0',
    itemGap: 5,
    textStyle: {
      fontSize: 15,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: '#666',
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 400,
      color: '#666',
      width: '100%',
    },
  },
  legend: {
    orient: 'horizontal',
    bottom: '0',
    left: '0',
    itemHeight: '11',
    selectedMode: true,
    itemStyle: {},
    textStyle: {
      fontSize: 12,
      lineHeight: 12,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: '#666',
    },
  },
  toolbox: {
    show: true,
    right: '0',
    top: '0',
    emphasis: {
      iconStyle: {
        borderColor: '#ffcd00',
        textFill: '#666',
      },
    },
    feature: {
      saveAsImage: {
        title: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('download'),
        textStyle: {
          fontSize: 6,
          fontFamily: 'Montserrat',
          fontWeight: 300,
        },
      },
    },
  },
  tooltip: {
    trigger: 'item',
    confine: true,
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
    },
    formatter (param) {
      return (
        `<b style="color: #666;">${capitalizarTexto(param.name)}</b><br />` +
        `${addPointInteger(param.value)} ${ 
        TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('intervenciones')}`
      );
    },
  },
  series: [
    {
      type: 'pie',
      radius: '40%',
      center: ['50%', '40%'],
      startAngle: 20,
      data: [],
      label: {
        show: false,
        textStyle: {
          fontFamily: 'Montserrat',
          fontSize: 10,
          lineHeight: 12,
        },
        formatter(param) {
          return `${capitalizarTexto(param.name)}\n${addPointInteger(
            param.percent,
          )}%`;
        },
        distanceToLabelLine: 3,
      },
      labelLine: {
        show: true,
        length: 10,
      },
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  ],
  media: [
    {
      // titles maxHeight: 410
      query: {
        maxHeight: 410,
      },
      option: {
        title: {
          itemGap: 3,
          textStyle: {
            fontSize: 13,
          },
          subtextStyle: {
            fontSize: 10,
          },
        },
      },
    },
    {
      query: {
        minWidth: 527,
      },
      option: {
        legend: {
          show: false,
        },
        series: {
          center: ['50%', '53%'],
          label: {
            show: true,
            textStyle: {
              fontSize: 12,
              lineHeight: 14,
            },
            distanceToLabelLine: 5,
          },
          labelLine: {
            show: true,
            length: 15,
          },
          emphasis: {
            label: {
              show: true,
            },
          },
        },
      },
    },
    {
      query: {
        minWidth: 527,
        minHeight: 318,
      },
      option: {
        series: {
          radius: '45%',
          labelLine: {
            show: true,
          },
        },
      },
    },
    {
      query: {
        minWidth: 700,
      },
      option: {
        series: {
          center: ['51%', '50%'],
          radius: '50%',
          startAngle: 60,
          label: {
            show: true,
            textStyle: {
              fontSize: 12,
              lineHeight: 18,
            },
          },
        },
      },
    },
  ],
};

// Gráficas pestañas HOY/MENSUAL/ANUAL | Barras de Intervenciones Seguridad Ciudadana por barrio
export const OPTIONS_INTERVENCIONES_BAR = {
  color: [COLORS.naranjaPalido, COLORS.tealPalido],
  grid: {
    left: '0',
    right: '0',
    bottom: '0',
    top: '50',
    containLabel: true,
  },
  title: {
    text: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('tipologia_seguridad'),
    subtext: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('barrio'),
    top: '0',
    left: 'center',
    itemGap: 5,
    textStyle: {
      fontSize: 15,
      lineHeight: 15,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: '#666',
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 400,
      color: '#666',
    },
  },
  toolbox: {
    show: true,
    right: '0',
    top: '0',
    emphasis: {
      iconStyle: {
        borderColor: '#ffcd00',
        textFill: '#666',
      },
    },
    feature: {
      saveAsImage: {
        title: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('download'),
        textStyle: {
          fontSize: 6,
          fontFamily: 'Montserrat',
          fontWeight: 300,
        },
      },
    },
  },
  tooltip: {
    trigger: 'item',
    confine: true,
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
    },
    formatter: (param) =>
      `<b style="color: #666;">${capitalizarTexto(
        param.name,
      )}</b><br /> ${addPointInteger(param.value)} ${TEXTS_SEGURIDAD[
        DEFAULT_LANGUAGE
      ].get('intervenciones')} `,
  },
  xAxis: {
    type: 'category',
    axisTick: { show: false },
    boundaryGap: ['20%', '20%'],
    gridIndex: 0,
    offset: 0,
    axisLine: {
      lineStyle: {
        color: '#ccc',
      },
    },
    axisLabel: {
      show: true,
      interval: 0,
      rotate: 50,
      padding: 0,
      margin: 5,
      verticalAlign: 'top',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      color: '#333',
      fontSize: 9,
      lineHeight: 10,
      formatter (value) {
        return capitalizarTexto(value);
      },
    },
    data: [],
  },
  yAxis: {
    type: 'value',
    gridIndex: 0,
    offset: 0,
    axisLabel: {
      textStyle: {
        fontSize: 10,
        fontFamily: 'Montserrat',
        fontWeight: 400,
      },
    },
  },
  series: [
    {
      data: [],
      type: 'bar',
      barWidth: 10,
    },
  ],
  media: [
    {
      // titles maxHeight: 240
      query: {
        maxHeight: 245,
      },
      option: {
        title: {
          itemGap: 3,
          textStyle: {
            fontSize: 13,
          },
          subtextStyle: {
            fontSize: 10,
          },
        },
      },
    },
    {
      // barWidth peq
      query: {
        maxWidth: 584,
      },
      option: {
        series: {
          barWidth: 10,
        },
      },
    },
    {
      // barWidth big
      query: {
        minWidth: 585,
      },
      option: {
        series: {
          barWidth: 16,
        },
      },
    },
  ],
};

// Gráficas pestañas HOY/MENSUAL/ANUAL | Barras apiladas de Intervenciones Totales Evolución
export const OPTIONS_INTERVENCIONES_STACKED = {
  color: Object.values(COLORS),
  grid: {
    left: '0',
    right: '0',
    bottom: '10',
    top: '50',
    containLabel: true,
  },
  title: {
    text: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('intervenciones_totales'),
    subtext: '',
    top: '0',
    left: 'center',
    itemGap: 5,
    textStyle: {
      fontSize: 15,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: '#666',
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 400,
      color: '#666',
    },
  },
  legend: {
    data: [],
    show: false,
  },
  toolbox: {
    show: true,
    right: '0',
    top: '0',
    emphasis: {
      iconStyle: {
        borderColor: '#ffcd00',
        textFill: '#666',
      },
    },
    feature: {
      saveAsImage: {
        title: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('download'),
        textStyle: {
          fontSize: 6,
          fontFamily: 'Montserrat',
          fontWeight: 300,
        },
      },
    },
  },
  tooltip: {
    confine: true,
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
    },
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisTick: { show: false },
      boundaryGap: ['20%', '20%'],
      gridIndex: 0,
      offset: 0,
      axisLine: {
        lineStyle: {
          color: '#ccc',
        },
      },
      axisLabel: {
        show: true,
        interval: 'auto',
        textStyle: {
          fontFamily: 'Montserrat',
          fontSize: 10,
          color: '#333',
        },
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      gridIndex: 0,
      offset: 0,
      axisLabel: {
        textStyle: {
          fontSize: 10,
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
        formatter: (value) => addPointInteger(Math.round(value)),
      },
    },
  ],
  series: [
    {
      data: [],
      type: 'bar',
    },
  ],
};

// Gráfica pestaña HOY | Barra horizontal de Top Intervenciones Nivel 3
export const OPTIONS_INTERVENCIONES_TOP = {
  color: COLORS.naranjaPalido,
  grid: {
    left: '0',
    right: '20',
    bottom: '65',
    top: '45',
    containLabel: true,
  },
  title: {
    text: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('top_5'),
    subtext: `${TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('tipologia_nivel')  } 3`,
    top: '0',
    left: 'center',
    itemGap: 5,
    textStyle: {
      fontSize: 15,
      fontFamily: 'Montserrat',
      fontWeight: 500,
      color: '#666',
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      color: '#666',
    },
  },
  legend: { show: false },
  toolbox: {
    show: true,
    right: '0',
    top: '0',
    feature: {
      saveAsImage: {
        title: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('download'),
        textStyle: {
          fontSize: 6,
          fontFamily: 'Montserrat',
          fontWeight: 300,
        },
      },
    },
  },
  tooltip: {
    trigger: 'item',
    confine: true,
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: '500',
    },
    formatter:
      `<b style="color: #666;">{b}</b><br />{c} ${ 
      TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('intervenciones')}`,
  },
  xAxis: {
    type: 'value',
    data: [],
    show: false,
    axisLabel: { show: false },
  },
  yAxis: {
    type: 'category',
    data: [],
    show: false,
    axisLabel: { show: false },
  },
  series: [
    {
      type: 'bar',
      data: [],
      yAxisIndex: '0',
      barMinWidth: '15',
      barGap: 0,
      label: {
        show: true,
        position: 'insideLeft',
        offset: [5, 0],
        distance: 0,
        padding: 0,
        height: '100%',
        textStyle: {
          fontSize: 13,
          fontFamily: 'Montserrat',
          color: '#000',
        },
        formatter: '{c} {b} ',
      },
    },
  ],
  media: [
    {
      // titles maxHeight: 240
      query: {
        maxHeight: 240,
      },
      option: {
        title: {
          itemGap: 3,
          textStyle: {
            fontSize: 13,
          },
          subtextStyle: {
            fontSize: 10,
          },
        },
      },
    },
    {
      // escritorio
      query: {
        maxWidth: 390,
        maxHeight: 415,
      },
      option: {
        yAxis: {
          boundaryGap: [0, 0],
        },
        series: [
          {
            xAxisIndex: '0',
            yAxisIndex: '0',
            barMinWidth: '15',
            barGap: 0,
          },
        ],
      },
    },
    {
      // grid bottom
      query: {
        maxHeight: 239,
      },
      option: {
        grid: {
          bottom: '70',
        },
      },
    },
  ],
};

// Gráficas pestañas MENSUAL/ANUAL | Árbol de Intervenciones por tipo
export const OPTIONS_INTERVENCIONES_TREE_MAP = {
  grid: {
    left: '0',
    right: '0',
    bottom: '40',
    top: '0',
    containLabel: true,
  },
  title: {
    text: TEXTS_SEGURIDAD[DEFAULT_LANGUAGE].get('intervenciones_tipo'),
    padding: [0, 25, 5, 25],
    top: '0',
    left: 'center',
    itemGap: 5,
    backgroundColor: '#fafafa',
    width: '100%',
    textStyle: {
      fontSize: '15',
      fontFamily: 'Montserrat',
      fontWeight: '500',
      color: '#666',
    },
    subtextStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
      fontWeight: 400,
      color: '#666',
    },
  },
  legend: { show: false },
  tooltip: {
    formatter (params) {
      return `<b>${capitalizarTexto(params.name)}</b><br/>${addPointInteger(
        params.data.originalValue,
      )} ${params.seriesName}`;
    },
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 12,
    },
  },
  series: [
    {
      name: 'Intervenciones',
      type: 'treemap',
      leafDepth: 1,
      width: '100%',
      height: '80%',
      top: 'middle',
      visibleMin: 0,
      roam: false,
      nodeClick: 'zoomToNode',
      colorMappingBy: 'index',
      itemStyle: {
        gapWidth: 3,
      },
      minVisibleSize: 20,
      label: {
        show: true,
        textStyle: {
          fontFamily: 'Montserrat',
          fontWeight: 400,
        },
        position: 'insideBottomLeft',
        formatter: (value) => value,
      },
      labelLine: { show: false },
      levels: [
        {
          itemStyle: {
            borderColor: '#fafafa',
            borderWidth: 1,
            gapWidth: 0,
          },
        },
        {
          colorSaturation: [0.3, 0.6],
          itemStyle: {
            borderColorSaturation: 0.7,
            gapWidth: 2,
            borderWidth: 2,
          },
        },
        {
          colorSaturation: [0.5, 0.7],
          itemStyle: {
            borderColorSaturation: 0.5,
            gapWidth: 1,
          },
        },
        {
          colorSaturation: [0.3, 0.5],
        },
      ],
      breadcrumb: {
        show: true,
        bottom: '50%',
        left: 'center',
        top: 'bottom',
        height: '22',
        emptyItemWidth: '25',
        itemStyle: {
          color: '#f1f1f1',
          borderColor: '#ddd',
          textStyle: {
            fontFamily: 'Montserrat',
            fontSize: 12,
            lineHeight: '22',
            height: '22',
            fontWeight: '600',
            overflow: 'truncate',
            ellipsis: true,
            color: '#333',
          },
        },
        emphasis: {
          itemStyle: {
            color: '#fff',
            borderColor: '#ccc',
            textStyle: {
              fontFamily: 'Montserrat',
              fontSize: 12,
              lineHeight: '22',
              height: '22',
              fontWeight: '600',
              overflow: 'truncate',
              ellipsis: true,
              color: '#000',
            },
          },
        },
      },
      data: [],
    },
  ],
  media: [
    {
      // titles maxHeight: 370
      query: {
        maxHeight: 370,
      },
      option: {
        title: {
          itemGap: 3,
          textStyle: {
            fontSize: 13,
          },
          subtextStyle: {
            fontSize: 10,
          },
        },
      },
    },
  ],
};
